// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"110":"95a8d74d","997":"fb2aa5f1"}[chunkId] + ".chunk.css";
};